module.exports = __webpack_public_path__ + "img/PrismNet_logo.c6dc85a2.png";